import { render, staticRenderFns } from "./StuffSettingPanel.vue?vue&type=template&id=7748a8fa&scoped=true"
import script from "./StuffSettingPanel.vue?vue&type=script&lang=js"
export * from "./StuffSettingPanel.vue?vue&type=script&lang=js"
import style0 from "./StuffSettingPanel.vue?vue&type=style&index=0&id=7748a8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7748a8fa",
  null
  
)

export default component.exports